import React, { useState, useEffect } from 'react';
import _  from 'lodash';
import { TextField, CircularProgress, Autocomplete } from '@mui/material';
import callApi from '../utils/api';
import { parseParams } from '../utils';
import { getAll } from '../store/course/courseBaseApi';

const SearchableSelect = ({label, endpoint = '', defaultValue, data=[], queryFieldName = 'query', overrideFilter=true, getOptionLabel, onChange, ...props }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    if (!getOptionLabel || typeof getOptionLabel !== 'function') {
        getOptionLabel = (option) => option.label;
    }

    useEffect(() => {
        if (data && data.length) {
            setOptions(data);
            return setLoading(false);
        }
        if (!endpoint) return;
        let active = true;

        if (!loading) {
            return undefined;
        }

        debouncedFetchResults(inputValue, active);

        return () => {
            active = false;
        };
    }, [loading, inputValue]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const fetchResults = async (value, active) =>  {
        try {
            let {data} = await getAll({
                payload: {
                    [queryFieldName]: value
                }
            })
    
            if (active) {
                setOptions(data.data);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    const debouncedFetchResults = React.useCallback(_.debounce(fetchResults, 300), []);

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        if (newInputValue) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    };

    const handleOnChange = (e, value) => {
        console.log('Selected item:', value)
    }

    const renderInput = (params) => {

        return <TextField
            {...params}
            label={label}
            variant="outlined"
            InputProps={{
                ...params.InputProps,
                endAdornment: (
                    <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </>
                ),
            }}
        />
    }

    const opts = {};

    if (overrideFilter) {
        opts.filterOptions = (opt) => opt;
    }

    return (

        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
                setLoading(false);
            }}
            onInputChange={handleInputChange}
            onChange={onChange || handleOnChange}
            getOptionLabel={getOptionLabel}
            options={options}
            loading={loading}
            value={defaultValue || []}
            renderInput={renderInput}
            noOptionsText="No options found"
            {...opts}
            {...props}
        />
    );
};

export default SearchableSelect;